import { jsxs, jsx } from "react/jsx-runtime";
import { Stack, Typography } from "@mui/material";
import SvgCheckbox from "./images/checkbox.svg.js";
import SvgCheckboxChecked from "./images/checkboxChecked.svg.js";
import SvgCheckboxCheckedMinus from "./images/checkboxCheckedMinus.svg.js";
import { StyledFormControlLabel, CheckboxStyled, CheckboxMessageStyled } from "./styles.js";
const Checkbox = ({
  label,
  isError,
  message,
  value: val,
  disabled,
  onChange,
  sx,
  ...props
}) => {
  const value = val ?? props.checked;
  return /* @__PURE__ */ jsxs(
    Stack,
    {
      className: "CheckboxContainer",
      sx,
      "data-test-id": props["data-test-id"],
      children: [
        /* @__PURE__ */ jsx(
          StyledFormControlLabel,
          {
            control: /* @__PURE__ */ jsx(
              CheckboxStyled,
              {
                ...props,
                icon: /* @__PURE__ */ jsx(SvgCheckbox, {}),
                checkedIcon: /* @__PURE__ */ jsx(SvgCheckboxChecked, {}),
                indeterminateIcon: /* @__PURE__ */ jsx(SvgCheckboxCheckedMinus, {}),
                indeterminate: (props == null ? void 0 : props.indeterminate) && value,
                checked: value,
                disabled,
                color: isError ? "error" : "primary",
                onChange
              }
            ),
            label: typeof label == "string" ? /* @__PURE__ */ jsx(Typography, { variant: "14_18_500", children: label }) : label
          }
        ),
        message && /* @__PURE__ */ jsx(CheckboxMessageStyled, { isError, children: message })
      ]
    }
  );
};
export {
  Checkbox
};
//# sourceMappingURL=Checkbox.js.map
